<script setup lang="ts">
import { computed } from 'vue'
import {
  type ReplyPreviewAttachment,
  getReplyPreviewFromMessage,
} from '@/modules/chat-matrix-fast/utils/replyPreview'
import ReplyPreviewThumbnail from './ReplyPreviewThumbnail.vue'

interface Props {
  replyTo: {
    content?: string
    message?: string
    attachments?: ReplyPreviewAttachment[]
    created_by?: {
      full_name?: string
      user_name?: string
    }
  }
  senderName: string
  isMine: boolean
  sourceAttachments?: ReplyPreviewAttachment[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  click: [event: MouseEvent | KeyboardEvent]
}>()

const replyPreview = computed(() =>
  getReplyPreviewFromMessage({
    content: props.replyTo.content || props.replyTo.message,
    message: props.replyTo.message,
    attachments: props.replyTo.attachments?.length
      ? props.replyTo.attachments
      : props.sourceAttachments,
  }),
)

const onActivate = (event: MouseEvent | KeyboardEvent) => {
  emit('click', event)
}
</script>

<template>
  <div
    v-if="replyTo"
    class="message-reply-context"
    :class="isMine ? 'chat-right' : 'chat-left'"
    role="button"
    tabindex="0"
    @click="onActivate"
    @keydown.enter.prevent="onActivate"
    @keydown.space.prevent="onActivate"
  >
    <div class="message-reply-line" />
    <ReplyPreviewThumbnail
      v-if="replyPreview.thumbnail"
      :src="replyPreview.thumbnail"
    />
    <div class="message-reply-content">
      <div class="message-reply-sender">
        {{ senderName }}
      </div>
      <div class="message-reply-text">
        {{ replyPreview.text }}
      </div>
    </div>
  </div>
</template>
